import Admin from '../containers/admin/Admin';
import DossierDetails from '../containers/dossier-details/DossierDetails';
import Dossiers from '../containers/dossiers/Dossiers';
import OfferingDetails from '../containers/offering-details/OfferingDetails';
import Offerings from '../containers/offerings/Offerings';
import {
  ADMIN_PATH,
  DOSSIERS_PATH,
  DOSSIER_DETAIL_PATH,
  OFFERINGS_DETAIL_PATH,
  OFFERINGS_PATH
} from './paths.constants';
import { PERMISSIONS } from './permissions.constants';

const PERMISSIONS_WITHOUT_LOWEST = Object.values(PERMISSIONS).filter(
  (p) => ![PERMISSIONS.PARTNER_NIET_FREQUENT, PERMISSIONS.SCHOOL_MEDEWERKER].includes(p)
);

export const ROUTES = [
  {
    path: ADMIN_PATH,
    component: Admin,
    orPermissions: PERMISSIONS_WITHOUT_LOWEST,
    permission: ''
  },
  {
    path: DOSSIERS_PATH,
    component: Dossiers,
    orPermissions: Object.values(PERMISSIONS),
    permission: ''
  },
  {
    path: DOSSIER_DETAIL_PATH,
    component: DossierDetails,
    orPermissions: Object.values(PERMISSIONS),
    permission: ''
  },
  {
    path: OFFERINGS_PATH,
    component: Offerings,
    permission: '',
    isPublic: true
  },
  {
    path: OFFERINGS_DETAIL_PATH,
    component: OfferingDetails,
    permission: '',
    isPublic: true
  }
];

export const ROUTES_WITH_SIDEBAR = ['/dossiers'];
